export const DEFAULT_TITLE_PREFIX = 'Kanda';
export const DEFAULT_TITLE_MIDDLE = 'Staff Portal';
export const DEFAULT_SEPARATOR = '|';
